import $ from 'jquery';
import $script from 'scriptjs';
import debounce from 'just-debounce';
import CurrencyConverter from 'shopify-currency-converter';

import Forms from '../Forms';
import MessageBanner from '../components/MessageBanner';

// import ProductUpsell from '../components/ProductUpsell';

export default class StaticCart {
  constructor(section) {
    this.settings = section.data.settings;
    this.shipping = section.data.shipping;
    this.messageBanner = new MessageBanner();

    this.$window = $(window);
    this.$el = $(section.el);
    this.$header = $('.site-header-wrapper');
    this.$total = this.$el.find('[data-cart-total]');
    this.$shipping = this.$el.find('[data-cartshipping]');

    // Product form containers
    this.$titleTotalSmall = this.$el.find('.cart-title-total--small');
    this.$titleTotalLarge = this.$el.find('.cart-title-total--large');
    this.$titleTotalContents = this.$el.find('[data-cart-title-total]');

    // Shipping calculator elements
    this.$shippingToggle = this.$el.find('[data-cartshipping-toggle]');
    this.$shippingResponse = this.$shipping.find('[data-cartshipping-response]');
    this.$shippingResponseMessage = this.$shippingResponse.find('[data-cartshipping-message]');
    this.$shippingResponseRates = this.$shippingResponse.find('[data-cartshipping-rates]');
    this.$shippingSubmit = this.$shipping.find('[data-cartshipping-submit]');

    this._moveTitleTotal();

    const $scripts = $('[data-scripts]');

    $script($scripts.data('shopify-api-url'), () => {
      this._bindEvents();

      Shopify.onError = this._handleErrors.bind(this);
    });

    this.forms = new Forms(this.$el);

    // Update the section when onSectionLoad fires to restore prices to local currency
    this.$el.find('.money').each((index, el) => CurrencyConverter.update(el));

    if (this.settings.shipping && this.$shipping.length) {
      $script($scripts.data('shopify-countries'), () => {
        $script($scripts.data('shopify-common'), () => {
          $script($scripts.data('shopify-cart'), () => {
            this._initShippingCalc();
          });
        });
      });
    }
  }

  onSectionUnload() {
    this.$el.off('.cart-page');
    this.$window.off('.cart-page');
    this.forms.unload();
    this.messageBanner.unload();
    this.messageBanner.dismissBanners();
  }

  _bindEvents() {
    this.$el.on('keydown.cart-page', '[data-cartitem-quantity]', (event) => {
      this._quantityKeyDown(event);
    });

    this.$el.on('change.cart-page', '[data-cartitem-quantity]', (event) => {
      event.stopImmediatePropagation();
      this._editItemQuantity(event);
    });

    this.$el.on('click.cart-page', '[data-cartitem-remove]', (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      this._editItemQuantity(event, true);
    });

    this.$window.on('resize.cart-page', debounce(() => this._moveTitleTotal(), 20));
    // Init Upsell Product
    // ProductUpsell.init(this.$el.find('.upsell-product').first(), {
    //   moneyFormat: this.settings.money_format,
    //   handle: document.querySelectorAll('[data-cartitem]')
    // }, 'cart');

    var check = false;
    $('#special-order-condition-check').click((e)=>{
      if(!check) {
        $(e.currentTarget).prop('checked', true);
        check = !check;
      } else {
        $(e.currentTarget).prop('checked', false);
        check = !check;
      }
      if($(e.currentTarget).prop('checked')) {
        $('button[name="checkout"]').removeClass('special-order-checkout');
        $('button[name="checkout"]').prop('disabled', false);
      } else {
        $('button[name="checkout"]').addClass('special-order-checkout');
        $('button[name="checkout"]').prop('disabled', true);
      }
    })
  }

  _moveTitleTotal() {
    if (!this.$titleTotalContents.length) {
      return;
    }

    if (this.$window.outerWidth() >= 480) {
      if (!$.contains(this.$titleTotalLarge[0], this.$titleTotalContents[0])) {
        const $form = this.$titleTotalContents.detach();
        this.$titleTotalLarge.append($form);
      }
    } else {
      if (!$.contains(this.$titleTotalSmall[0], this.$titleTotalContents[0])) {
        const $form = this.$titleTotalContents.detach();
        this.$titleTotalSmall.append($form);
      }
    }
  }

  /**
   * Prevent form submission when pressing `enter` within a quantity selector
   *
   * @param event
   * @private
   */
  _quantityKeyDown(event) {
    // Only block enter keys
    if (event.keyCode !== 13) {
      return;
    }

    // Block form submission, but update field
    $(event.currentTarget).trigger('change');

    event.preventDefault();
  }

  /**
   * Handle an item quantity change
   *
   * @param event
   * @param {Boolean} remove - Set as true to remove cart item
   * @private
   */
  _editItemQuantity(event, remove = false) {
    this.messageBanner.dismissBanners();

    const $target = $(event.currentTarget);
    const $cartItem = $target.closest('[data-cartitem-id]');

    let quantity = remove ? 0 : parseInt($target.val(), 10);
    quantity = Math.max(quantity, 0);

    this._updateCart($cartItem, quantity);

    // Extra
    let currentState = $cartItem.parent().hasClass('out-stock') ? 0 : 1,
    inventory = $cartItem.data('cartitem-quantity'),
    inStockList = this.$el.find('.in-stock.cartitems--list'),
    outStockList = this.$el.find('.out-stock.cartitems--list'),
    outTitle = this.$el.find('.cartitems .out-stock'),
    inTitle = this.$el.find('.cartitems .in-stock');

    // Remove item from cart visually if it is being removed
    if (quantity === 0 || remove) {
      $cartItem.height($cartItem.height())
      setTimeout(() => {
        if (currentState === 0) {
          if (outStockList.find('li').length === 0) outTitle.removeClass('shown');
        } else {
          if (inStockList.find('li').length === 0) inTitle.removeClass('shown');
        }
      }, 1000)
    } else {
      if (inventory >= quantity && currentState === 0) {
        // move to in stock
        $cartItem.detach().appendTo(inStockList);
        inTitle.addClass('shown');
        // Hide out stock
        if (outStockList.find('li').length === 0) outTitle.removeClass('shown');
      } else if (inventory < quantity && currentState === 1) {
        // move to out stock
        $cartItem.detach().appendTo(outStockList);
        outTitle.addClass('shown');
        // hide in stock
        if (inStockList.find('li').length === 0) inTitle.removeClass('shown');
      }
    }
  }

  /**
   * Update cart with a valid quantity
   *
   * @param $cartItem
   * @param quantity
   * @private
   */
  _updateCart($cartItem, quantity) {
    const id = $cartItem.data('cartitem-id');

    // Notify Shopify updated item
    Shopify.changeItem(id, quantity, (response) => {
      this._didUpdate(id, quantity,response, $cartItem);
    });
  }

  _quantityError(limit, title) {
    const errorMessage = this.settings.stock_limit
      .replace('** quantity **', limit)
      .replace('** title **', title);

    this.messageBanner.message(errorMessage, 'error');
  }

  /**
   * Update cart content based on information from Shopify
   *
   * @param id
   * @param quantity
   * @param response
   * @param $cartItem
   * @returns {*}
   * @private
   */
  _didUpdate(id, quantity,response, $cartItem) {
    // Reload page if all items are removed from cart
    if (!response.items.length) {
      return window.location = '/cart';
    }

    this.$header.trigger('cartcount:update', { response });

    this.$total.each((i, el) => {
      el.innerHTML = Shopify.formatMoney(response.total_price, this.settings.money_format);
      CurrencyConverter.update(el);
    });

    // Select item from response
    const filteredItems = response.items.filter(item => item.id === id);

    if(!filteredItems.length) {
      return $cartItem.addClass('removing')
        .one('trend', () => {
          $cartItem
            .off('trend')
            .remove();
        });
    }

    const cartItem = filteredItems[0];
    const itemTotal = $cartItem[0].querySelector('[data-cartitem-total]');

    if (cartItem.quantity !== quantity) {
      this._quantityError(cartItem.quantity, cartItem.title);
      $cartItem.find('[data-quantity-input]').val(cartItem.quantity);
      $cartItem.find('[data-quantity-select]').val(cartItem.quantity);
    }

    itemTotal.innerHTML = Shopify.formatMoney(cartItem.price * cartItem.quantity, this.settings.money_format);
    CurrencyConverter.update(itemTotal);
  }

  /**
   * Handle Errors returned from Shopify
   *
   * @param xhr
   * @private
   */
  _handleErrors(xhr = null) {
    if (!xhr) {
      return;
    }

    const errors = $.parseJSON(xhr.responseText);
    const shippingResponse = {
      message: this.shipping.error_general,
    };

    if (errors.zip && errors.zip.length > 0) {
      if (errors.zip[0].indexOf('is not valid') !== -1 || errors.zip[0].indexOf('can\'t be blank') !== -1) {
        shippingResponse.message = `${this.shipping.zip} ${errors.zip}`;
      }
    }

    if (errors.error && errors.error.length > 0) {
      if (errors.error[0].indexOf('shipment_too_heavy') !== -1) {
        shippingResponse.message = this.shipping.shipment_too_heavy;
      }
    }

    this._handleShippingResponse(shippingResponse);
  }

  _initShippingCalc() {
    this._bindShippingCalcEvents();

    Shopify.Cart.ShippingCalculator.show({
      submitButton: this.shipping.calculate_shipping,
      submitButtonDisabled: this.shipping.calculating,
      customerIsLoggedIn: this.shipping.customer,
      moneyFormat: this.settings.money_format,
    });
  }

  _bindShippingCalcEvents() {
    this.$el.on('click.cart-page', '[data-cartshipping-toggle]', () => {
      this._toggleShippingCalc();
    });

    this.$el.on('click.cart-page', '[data-cartshipping-submit]', () => {
      this._getShippingRates();
    });

    this.$el.on('keypress.cart-page', '#address_zip', (event) => {
      if (event.keyCode === 10 || event.keyCode === 13) {
        event.preventDefault();
        this.$shippingSubmit.trigger('click');
      }
    });
  }

  _toggleShippingCalc() {
    const oldText = this.$shippingToggle.text();
    const newText = this.$shippingToggle.data('cartshipping-toggle');

    this.$shippingToggle
      .text(newText)
      .data('cartshipping-toggle', oldText);

    this.$shipping.toggleClass('open');
  }

  _getShippingRates() {
    this._disableShippingButton();

    const shippingAddress = {};
    shippingAddress.country = $('#address_country').val() || '';
    shippingAddress.province = $('#address_province').val() || '';
    shippingAddress.zip = $('#address_zip').val() || '';

    // Creates an ajax request which returns shipping information
    Shopify.getCartShippingRatesForDestination(shippingAddress, (response, shippingAddress) => {
      const addressBase = [];

      if (shippingAddress.zip.length) {
        addressBase.push(shippingAddress.zip.trim());
      }

      if (shippingAddress.province.length) {
        addressBase.push(shippingAddress.province);
      }

      if (shippingAddress.country.length) {
        addressBase.push(shippingAddress.country);
      }

      const address = addressBase.join(', ');

      let message = '';
      if (response.length > 1) {
        const firstRate = Shopify.Cart.ShippingCalculator.formatRate(response[0].price);
        message = this.shipping.multiple_rates
          .replace('*address*', address)
          .replace('*number_of_rates*', response.length)
          .replace('*rate*', `<span class="money">${firstRate}</span>`);
      } else if (response.length === 1) {
        message = this.shipping.one_rate.replace('*address*', address);
      } else {
        message = this.shipping.no_rates;
      }

      const rates = [];
      response.forEach((rate) => {
        const price = Shopify.Cart.ShippingCalculator.formatRate(rate.price);
        const rateValue = this.shipping.rate_value
          .replace('*rate_title*', rate.name)
          .replace('*rate*', `<span class="money">${price}</span>`);

        rates.push(`<li>${rateValue}</li>`);
      });

      this._handleShippingResponse({
        message,
        rates,
      });
    });
  }

  _enableShippingButton() {
    this.$shippingSubmit
      .text(this.shipping.calculate_shipping)
      .attr('disabled', false);
  }

  _disableShippingButton() {
    this.$shippingSubmit
      .text(this.shipping.calculating)
      .attr('disabled', true);
  }

  _showShippingResponse() {
    this.$shippingResponse.addClass('visible');
  }

  _hideShippingResponse() {
    this.$shippingResponse.removeClass('visible');
  }

  /**
   * Handle shipping responses
   *
   * @param {object} shippingResponse
   * @property {String} shippingResponse.messages - Error / Success message
   * @property {Array|String} shippingResponse.rates - Shipping rates
   * @private
   */
  _handleShippingResponse(shippingResponse = {}) {
    // Hide the response so that it can be populated smoothly
    this._hideShippingResponse();

    const message = shippingResponse.message || null;
    const rates = shippingResponse.rates || null;

    // Empty out contents
    this.$shippingResponseMessage.empty();
    this.$shippingResponseRates.empty();

    if (message) {
      this.$shippingResponseMessage.html(message);
    }

    if (rates) {
      this.$shippingResponseRates.html(rates);
    }

    // Reset the calculating button so it can be used again
    this._enableShippingButton();

    // No error provided
    if (!message && !rates) {
      return;
    }

    // Show the response
    this._showShippingResponse();
  }
}
